// extracted by mini-css-extract-plugin
module.exports = {"menuItem":"dropdownActionItem_menuItem__3ZqXV","itemText":"dropdownActionItem_itemText__4YNKv","itemIcon":"dropdownActionItem_itemIcon__1iQSx"};